import React, { Component } from 'react';
// import { Container, Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Route, Routes } from "react-router-dom";
import ProductSetup from './Create/ProductSetup/index';
import MisFieldSetup from './Create/MisFieldSetup/index';
import CreateCorporateComponent from './Create/CompanySetup/index';
import ScorecardSetupComponent from './Create/ScorecardSetup/index';
import CorporateSetupProgress from './SetupProgress/index'
import { Preloading } from '../../components/UI/Preloader/action';
import { connect } from 'react-redux';
import * as corporateCreateAction from './Create/action'
import withRouter from '../../withRouter';

const CreateCorporateComponentWithRouter = withRouter(CreateCorporateComponent);
const ProductSetupWithRouter = withRouter(ProductSetup);
const ScorecardSetupComponentWithRouter = withRouter(ScorecardSetupComponent);
const MisFieldSetupWithRouter = withRouter(MisFieldSetup);

class CorparateOnBoarding extends Component {
    constructor() {
        super();
        this.state = {
            setUpProgress: {
                companySetupProgress: 'setup-progress-element',
                productSetupProgress: 'setup-progress-element',
                misSetupProgress:'setup-progress-element',
                scorecardSetupProgress: 'setup-progress-element'
                
            }

        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.editData !== prevProps.editData) {
            this.props.preloading(false)
        }
    }
    componentWillUnmount() {
        this.props.setCompanySetup(null);
        this.props.setProductSetup([]);
        this.props.saveScorecardData([]);
        this.props.setCreditSetup("");
        this.props.getEditDataSuccess(null);
        this.props.setMisFieldSetup([]);
        this.props.setMisFields(null);
        this.props.setDefaultMisFields(null);
    }
    handleActiveProgressTab = (activeTab) => {
        this.setState(prevState => ({
            setUpProgress: {
                ...prevState.setUpProgress,
                productSetupProgress: activeTab,
                // scorecardSetupProgress:activeTab
                companyDetailsDisabled: false,
                productDetailsDisabled: true,
                misDetailsDisabled:true,
                scorecardDetailsDisabled: true
            }
        }))
    }
    handleActiveCompanyProgressTab = (activeTab) => {
        this.setState(prevState => ({
            setUpProgress: {
                ...prevState.setUpProgress,
                companySetupProgress: activeTab,
                companyDetailsDisabled: true,
                productDetailsDisabled: true,
                misDetailsDisabled:true,
                scorecardDetailsDisabled: true
            }
        }))
    }

    handleActiveEditCompanyProgressTab = (activeTab) => {
        this.setState(prevState => ({
            setUpProgress: {
                ...prevState.setUpProgress,
                companySetupProgress: activeTab,
                companyDetailsDisabled: true,
                productDetailsDisabled: false,
                misDetailsDisabled:false,
                scorecardDetailsDisabled: false
            }
        }))
    }

    handleActiveProgressTabScoreCard = (activeTab) => {
        this.setState(prevState => ({
            setUpProgress: {
                ...prevState.setUpProgress,
                scorecardSetupProgress: activeTab,
                companyDetailsDisabled: false,
                productDetailsDisabled: false,
                misDetailsDisabled:false,
                scorecardDetailsDisabled: true
            }
        }))
    }
    handleActiveProgressTabMisField= (activeTab) => {
        this.setState(prevState => ({
            setUpProgress: {
                ...prevState.setUpProgress,
                misSetupProgress: activeTab,
                companyDetailsDisabled: false,
                productDetailsDisabled: false,
                misDetailsDisabled:true,
                scorecardDetailsDisabled: true
            }
        }))
    }

    render() {
        return (
            <section className="corporate-onboarding">
                <CorporateSetupProgress setUpProgress={this.state.setUpProgress} />
                <Routes>
                    <Route exact path="companysetup" element={<CreateCorporateComponentWithRouter {...this.props} activeCompanyProgressTab={this.handleActiveCompanyProgressTab} activeEditCompanyProgressTab={this.handleActiveEditCompanyProgressTab} />} />
                    <Route exact path="productsetup" element={<ProductSetupWithRouter {...this.props} activeProgressTab={this.handleActiveProgressTab} />} />
                    <Route exact path="scorecardsetup" element={<ScorecardSetupComponentWithRouter {...this.props} activeProgressTab={this.handleActiveProgressTabScoreCard} />} />
                    <Route exact path="misfieldsetup" element={<MisFieldSetupWithRouter {...this.props} activeProgressTab={this.handleActiveProgressTabMisField} />} />
                </Routes>
            </section>
        )
    }
}
const mapStateToProps = (state) => ({
    editData: state.corporateOnBoardingCreate.editData
});

const mapDispatchToProps = (dispatch) => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    setCompanySetup: (data) => { dispatch(corporateCreateAction.setCompanySetup(data)) },
    setCorporateOnboardingStatus: (data) => { dispatch(corporateCreateAction.setCorporateOnboardingStatus(data)) },
    setProductSetup: (data) => { dispatch(corporateCreateAction.setProductSetup(data)) },
    saveScorecardData: (data) => { dispatch(corporateCreateAction.saveScorecardData(data)) },
    setCreditSetup: (data) => { dispatch(corporateCreateAction.setCreditSetup(data)) },
    getEditDataSuccess: (data) => { dispatch(corporateCreateAction.getEditDataSuccess(data)) },
    setMisFieldSetup:(data)=>{dispatch(corporateCreateAction.setMisFieldSetup(data))},
    setMisFields:(data)=>{dispatch(corporateCreateAction.setMisFields(data))},
    setDefaultMisFields:(data)=>{dispatch(corporateCreateAction.setDefaultMisFields(data))}
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(CorparateOnBoarding))